module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-h2-681302a9.svg";